module.exports = __webpack_public_path__ + "img/ribeiraobonito.7d322f0f.png";